import { useEffect } from 'react';
import { useFormContext } from './index';

export default (name, shouldRegister = true, form) => {
  const { register, unregister } = form ?? {};
  const formContext = useFormContext();
  const { register: contextRegister, unregister: contextUnregister } = formContext ?? {};
  const registerInput = register ?? contextRegister;
  const unregisterInput = unregister ?? contextUnregister;

  useEffect(() => {
    if (shouldRegister && registerInput) {
      registerInput({ name });
    }

    return () => {
      if (shouldRegister && unregisterInput) {
        unregisterInput(name);
      }
    };
  }, [registerInput, unregisterInput, name, shouldRegister]);
};
